"use client"

import type React from "react"
import { useState, useCallback, useEffect } from "react"
import styles from "./ProviderSelector.module.scss"
import InfiniteScrollSelect, {
  type SelectOption,
} from "../../../../../common/components/infinite-scroll-select/InfiniteScrollSelect"
import { useGetProvidersByCountryQuery } from "../../../../../service/solar-provider-service"

interface ProviderSelectorProps {
  className?: string
  onProviderSelected: (selectedProviderId: string) => void
  selectedProviderId: string;
  countryCode: string;
}

const ProviderSelector: React.FC<ProviderSelectorProps> = ({
  className = "",
  onProviderSelected,
  selectedProviderId,
  countryCode,
}) => {
  const [selectedProvider, setSelectedProvider] = useState<SelectOption | null>(null)
  const [displayedProviders, setDisplayedProviders] = useState<SelectOption[]>([])
  const [allProviders, setAllProviders] = useState<SelectOption[]>([])
  const [searchQuery, setSearchQuery] = useState("")
  
  const { data: providersData, isLoading } = useGetProvidersByCountryQuery(countryCode)


  useEffect(() => {
    if (providersData && Array.isArray(providersData)) {
      const formattedProviders = providersData.map((provider) => ({
        id: provider.id,
        label: provider.name,
        avatar: undefined,
      }))
      
      setAllProviders(formattedProviders)
      setDisplayedProviders(formattedProviders)
      
      if (selectedProviderId) {
        const currentProvider = formattedProviders.find((p) => p.id === selectedProviderId)
        if (currentProvider) {
          setSelectedProvider(currentProvider)
        }
      }
    }
  }, [providersData, selectedProviderId])

  const handleSearch = useCallback(
    (query: string) => {
      setSearchQuery(query)
      
      if (!query.trim()) {
        setDisplayedProviders(allProviders)
        return
      }
      
      const filteredProviders = allProviders.filter((provider) => 
        provider.label.toLowerCase().includes(query.toLowerCase())
      )
      
      setDisplayedProviders(filteredProviders)
    },
    [allProviders]
  )


  const handleSelectProvider = (option: SelectOption) => {
    setSelectedProvider(option)
    onProviderSelected(option.id)
  }

  return (
    <div className={`${styles.assign_provider} ${className}`}>
      <span className={styles.assign_provider_label}>Assigned Solar Provider</span>

      <div className={styles.assign_provider_select}>
      <InfiniteScrollSelect
          label=""
          options={displayedProviders}
          value={selectedProvider}
          onChange={handleSelectProvider}
          isLoading={isLoading}
          hasMore={false}
          onLoadMore={()=>{}}
          onSearch={handleSearch}
          emptyMessage="No providers found"
          assignLabel="Assign to"
        />
      </div>
    </div>
  )
}

export default ProviderSelector

